import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
//export const API = `${BACKEND_URL}/api`;
export const API = `/api`;

const ACCESS_KEY = "sr_access_token";
const REFRESH_KEY = "sr_refresh_token";

export function setTokens(access, refresh) {
  if (access) localStorage.setItem(ACCESS_KEY, access);
  if (refresh) localStorage.setItem(REFRESH_KEY, refresh);
}
export function clearTokens() {
  localStorage.removeItem(ACCESS_KEY);
  localStorage.removeItem(REFRESH_KEY);
}
export const getAccess = () => localStorage.getItem(ACCESS_KEY);
export const getRefresh = () => localStorage.getItem(REFRESH_KEY);

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Attach Bearer token (works even when 3rd-party cookies are blocked in the preview iframe)
api.interceptors.request.use((config) => {
  const token = getAccess();
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Auto-refresh on 401, then retry the original request once.
let refreshing = null;

api.interceptors.response.use(
  (res) => res,
  async (error) => {
    const original = error.config;
    const status = error.response?.status;
    const isAuthCall =
      original?.url?.includes("/auth/login") ||
      original?.url?.includes("/auth/refresh");

    if (status === 401 && original && !original._retried && !isAuthCall) {
      original._retried = true;
      try {
        if (!refreshing) {
          refreshing = axios
            .post(
              `${API}/auth/refresh`,
              {},
              {
                withCredentials: true,
                headers: { "X-Refresh-Token": getRefresh() || "" },
              }
            )
            .then((r) => {
              setTokens(r.data.access_token, r.data.refresh_token);
              return r;
            })
            .finally(() => {
              refreshing = null;
            });
        }
        await refreshing;
        original.headers.Authorization = `Bearer ${getAccess()}`;
        return api(original);
      } catch (e) {
        clearTokens();
        if (typeof window !== "undefined" && window.location.pathname !== "/login") {
          window.location.href = "/login";
        }
        return Promise.reject(e);
      }
    }
    return Promise.reject(error);
  }
);

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
